
export default function Hero() {
  return (
    <section 
      id="home" 
      className="relative min-h-screen bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(34, 139, 34, 0.7), rgba(255, 215, 0, 0.3)), url('https://readdy.ai/api/search-image?query=Professional%20beauty%20cosmetics%20laboratory%20with%20modern%20equipment%2C%20clean%20white%20surfaces%2C%20glass%20containers%20with%20colorful%20beauty%20products%2C%20soft%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20high-end%20beauty%20manufacturing%20facility%2C%20scientific%20precision%20meets%20luxury%20beauty%20industry&width=1920&height=1080&seq=hero-beauty-lab&orientation=landscape')`
      }}
    >
      <div className="container mx-auto px-4 py-20">
        <div className="flex items-center min-h-screen">
          <div className="w-full max-w-3xl">
            <div className="bg-white/90 p-8 rounded-lg shadow-2xl border-4 border-yellow-400">
              <h2 className="text-4xl md:text-6xl font-bold text-green-800 mb-6 leading-tight">
                美容の未来を<br />
                <span className="text-yellow-600">創造する</span>
              </h2>
              <p className="text-xl md:text-2xl text-gray-700 mb-8 leading-relaxed">
                株式会社MELMは、美容業界のプロフェッショナルから一般のお客様まで、<br />
                高品質な美容商材をお届けする専門企業です。
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="#products" 
                  className="bg-green-800 text-white px-8 py-4 rounded-lg hover:bg-green-700 transition-colors text-center font-semibold text-lg whitespace-nowrap cursor-pointer"
                >
                  商品カタログを見る
                </a>
                <a 
                  href="#contact" 
                  className="bg-yellow-500 text-green-800 px-8 py-4 rounded-lg hover:bg-yellow-400 transition-colors text-center font-semibold text-lg whitespace-nowrap cursor-pointer"
                >
                  お問い合わせ
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
